export const citologiaRoutes = (apiBase) => ({
  citologia: `${apiBase}/citologia`,
  citologiaCatalogos: `${apiBase}/citologia/catalogos`,
  citologiaPacientePorNumero: (numeroIdentificacion) =>
    `${apiBase}/citologia/paciente-por-numero?numero_identificacion=${encodeURIComponent(numeroIdentificacion)}`,
  citologiaPacientePorTipoNumero: (tipoId, numeroIdentificacion) =>
    `${apiBase}/citologia/paciente-por-tipo-numero?tipo_id=${encodeURIComponent(tipoId)}&numero_identificacion=${encodeURIComponent(numeroIdentificacion)}`,
  citologiaHistorico: (autoid) => `${apiBase}/citologia/historico?autoid=${encodeURIComponent(autoid)}`,
  citologiaDetalle: (idCitologia) => `${apiBase}/citologia/detalle?id_citologia=${encodeURIComponent(idCitologia)}`,
});
